import React, { useEffect } from 'react'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'
// import useSWR from 'swr'
// import { getData } from '../components/sfc/component-helpers/requesthelpers'
import Layout from '../components/layout'
import { useCanNativeLazyLoad } from '../components/sfc/component-helpers/customhooks'
import Topper from '../components/sfc/topper'
import RelatedSection from '../components/sfc/relatedsection'
import CreditsSection from '../components/sfc/creditssection'
import Personalizer from '../components/personalize/Personalizer'
import Subhed from '../components/elements/Subhed'
import Carousel from '../components/bills/Carousel'
import useStickyState from '../components/sfc/component-helpers/useStickyState'
import { useBillsToWatch } from '../components/sfc/component-helpers/useBillsToWatch'
import { useBillsToWatchSA } from '../components/sfc/component-helpers/useBillsToWatchSA'
import { useAllBills } from '../components/sfc/component-helpers/useAllBills'
import Card from '../components/bills/Card'
import Newsletter from '../components/sfc/newsletter'
import SafeLink from '../components/sfc/safelink'
import Ad from '../components/sfc/ad'
import SponsorBug from '../components/sfc/sponsorbug'
import {
  data_disclaimer
} from '../data/LegisTracker_all_states_text.json'
import storySettings from '../data/story_settings.sheet.json'

const IndexPage = ({ data, pageContext }) => {
  // easy hooks based request library
  // const { data: responseData, error } = useSWR('https://api.kanye.rest', getData, {
  //   onSuccess: (data) => console.log(data),
  //   onError: (err) => console.log(err),
  // })

  // custom hook checks for nativelazyload
  const lazy = useCanNativeLazyLoad()

  const {
    site: { siteMetadata },
    allRelatedLinksSheetJson: { nodes: relatedLinks },
    storySettingsSheetJson: { Title, Deck, Intro, NewsletterID },
    allAuthorsSheetJson: { nodes: Authors },
    allBillGroupsSheetJson: { nodes: billGroupNames },
    allCreditsSheetJson: {nodes: Credits}
  } = data  
  console.log(Credits)
  const billsToWatch = useBillsToWatch()
  let billsToWatchSA = useBillsToWatchSA()
  console.log(billsToWatch)
  const allBills = useAllBills()
  const { year: YEAR } = pageContext

  siteMetadata.PROJECT.AUTHORS = Authors
  const MARKET_KEY = siteMetadata.PROJECT.MARKET_KEY

  //set up sticky state so our lawmakers stay even on refresh
  let [yourLegislators, setYourLegislators] = useStickyState(
    null,
    'your_legislators'
  )

  const has_sponsor = storySettings.Is_Sponsored === 'TRUE'
  return (
    <Layout meta={siteMetadata}>
      <Topper meta={siteMetadata} Title={Title} Deck={Deck} Authors={Authors} />
      <main>
        <section className="intro">
          <div className="intro-text">
            <div dangerouslySetInnerHTML={{ __html: Intro }}></div>
            <br /> 
            <i>{data_disclaimer}</i>
          </div>
          <div className="personalize-container">
            <Personalizer
              yourLegislators={yourLegislators}
              setYourLegislators={setYourLegislators}
              MARKET_KEY={MARKET_KEY}
            />
          </div>
        </section>
        {has_sponsor && <SponsorBug />}
        <Ad adLetter='A'/>
        <section>
          <Subhed title="Bills to watch" />
          {MARKET_KEY !== "SanAntonio" && <Carousel
            YEAR={YEAR}
            publicationName={siteMetadata.PROJECT.PUB_NAME}
            cards={billsToWatch}
            MARKET_KEY={siteMetadata.PROJECT.MARKET_KEY}
          />}
          {MARKET_KEY === "SanAntonio" && <Carousel
          YEAR={YEAR}
          publicationName={siteMetadata.PROJECT.PUB_NAME}
          cards={billsToWatchSA}
          MARKET_KEY={siteMetadata.PROJECT.MARKET_KEY}
        />}
          {billGroupNames.map((group) => (
            <>
            {/* confirm there are bills assigned to the group before generating it */}
            { allBills.find((b) => b.bill_groups.includes(group.group_name)) && 
              <div id={group.group_slug ? group.group_slug : null}>
                <Subhed title={group.group_name} deck={group.group_deck} />
                <Carousel
                  YEAR={YEAR}
                  publicationName={siteMetadata.PROJECT.PUB_NAME}
                  cards={ 
                    allBills.filter((b) => b.bill_groups.includes(group.group_name))
                  }
                  MARKET_KEY={siteMetadata.PROJECT.MARKET_KEY}
                />
              </div>
            }
            </>
            
          ))}
        </section>
        <Ad adLetter='B'/>
        <section className={'all-bills'}>
          <Subhed title="All bills we’re tracking" />
          <ul>
            {allBills.map((bill) => (
              <Card
                bill={bill}
                minimal={true}
                publicationName={siteMetadata.PROJECT.PUB_NAME}
                MARKET_KEY={MARKET_KEY}
                YEAR={YEAR}
              />
            ))}
          </ul>
        </section>
      </main>
      { NewsletterID && <Newsletter />}
      <RelatedSection links={relatedLinks} />
      <CreditsSection creditData={Credits}/>
    </Layout>
  )
}

export const query = graphql`
  {
    storySettingsSheetJson {
      Title
      Deck
      Intro
      NewsletterID
    }
    allAuthorsSheetJson {
      nodes {
        AUTHOR_NAME
        AUTHOR_PAGE
      }
    }
    allBillGroupsSheetJson(skip: 1) {
      nodes {
        group_deck
        group_slug
        group_name
      }
    }
    allCreditsSheetJson(skip: 1) {
        nodes {
          id
          Email
          Instagram
          Name
          Organization
          Role
          Twitter
        }
      
    }
    site {
      siteMetadata {
        EMBEDDED
        MAIN_DOMAIN
        PAYWALL_SETTING
        PROJECT {
          PUB_NAME
          DATE
          DESCRIPTION
          HEARST_CATEGORY
          KEY_SUBJECTS
          IMAGE
          ISO_MODDATE
          ISO_PUBDATE
          OPT_SLASH
          SLUG
          SOCIAL_TITLE
          SUBFOLDER
          TITLE
          TWITTER_TEXT
          ANALYTICS_CREDIT
          MARKET_KEY
          CANONICAL_URL
        }
      }
    }
    allRelatedLinksSheetJson {
      nodes {
        wcmid
        title
        url
      }
    }
  }
`
IndexPage.propTypes = {
  data: PropTypes.object.isRequired,
}

export default IndexPage
